import NumberInput from '@/components/NumberInput';
import InfoTooltip from '@/components/Tooltip/InfoTooltip';
import { getFieldErrorProps } from '@/helpers/form';
import { FormLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { LINE_ITEM_FREQUENCY_CAPS_PERIODS_OPTIONS } from './constants';

interface IProps {
  index: number;
}

const FrequencyCaps = ({ index }: IProps) => {
  const { control } = useFormContext();
  const frequencyCaps = useWatch({ control, name: 'frequencyCaps' });

  const [filledFields, setFilledFields] = useState<string[]>([]);

  useEffect(() => {
    const filled = Object.keys(frequencyCaps).filter(key => frequencyCaps[key]);
    setFilledFields(filled);
  }, [frequencyCaps]);

  const isDisabled = (field: string) => filledFields.length >= 3 && !filledFields.includes(field);

  return (
    <div className='flex flex-col mt-3'>
      <FormLabel className='form-label-with-tooltip' aria-label='Frequency Caps'>
        Frequency Caps
        <InfoTooltip title='Maximum of three Frequency Caps can be selected' className='form-label-tooltip' />
      </FormLabel>
      <div className='flex gap-4'>
        {LINE_ITEM_FREQUENCY_CAPS_PERIODS_OPTIONS.map(({ label, value }) => (
          <div key={label} className='flex-1'>
            <FormLabel htmlFor={`freq-cap-${value}-${index}`}>{label}</FormLabel>
            <Controller
              name={`frequencyCaps.${value}`}
              control={control}
              render={({ field, fieldState }) => (
                <NumberInput
                  {...field}
                  // @ts-expect-error jsx component props
                  id={`freq-cap-${value}-${index}`}
                  fullWidth
                  disableInputArrows
                  NumberInputProps={{ thousandsSeparator: ',', unmask: true }}
                  disabled={isDisabled(value)}
                  placeholder='0'
                  {...getFieldErrorProps(fieldState)}
                />
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FrequencyCaps;
